import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MatRippleModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';

// Components go here
import { AppComponent } from './app.component';

// Services go here
import { UserService } from './user.service';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { PayComponent } from './pay/pay.component';
import { DonateComponent } from './donate/donate.component';
import { ScholarshipComponent } from './scholarship/scholarship.component';
import { PastEventsComponent } from './past-events/past-events.component';
import { SiteHeadComponent } from './site-head/site-head.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'pay-registration',      component: PayComponent },
  { path: 'donate',      component: DonateComponent },
  { path: 'scholarship',      component: ScholarshipComponent },
  { path: 'past-events',      component: PastEventsComponent },
  { path: '**', component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    HomeComponent,
    PayComponent,
    DonateComponent,
    ScholarshipComponent,
    PastEventsComponent,
    SiteHeadComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    MatRippleModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [UserService],
  bootstrap: [AppComponent]
})

export class AppModule {
 }



// WEBPACK FOOTER //
// ./src/app/app.module.ts